import { FC, Fragment } from 'react';
import { RefinementDropdown } from './RefinementDropdown';
import { RefinementListRow } from '~/features/productList/components/RefinementListRow';
import SwitchElement from '~/shared/components/form/components/controllable-elements/switch-element';
import { RefinementProps } from './RefinementProps';
import { useTranslation } from '~/shared/utils/translation';
import { useSalesOfferGroups } from '~/features/productList/hooks/useSalesOfferGroups';
import styles from './RefinementSalesOffersDropdown.module.scss';

export const RefinementSalesOffersDropdown: FC<RefinementProps> = ({ label, isVisible = true }) => {
    const { translate } = useTranslation();
    const {
        groupItems,
        selectedCount,
        isAllRefined,
        allCount,
        handleGroupRefine,
        handleAllRefine,
        handleSubItemRefine,
    } = useSalesOfferGroups();

    if (!isVisible) return null;

    return (
        <RefinementDropdown
            label={label}
            count={selectedCount}
            topContent={
                <>
                    <p className={styles.disclaimer}>{translate('plp.salesOffers.disclaimer')}</p>

                    <div className={styles.allRow}>
                        <SwitchElement
                            checked={isAllRefined}
                            onChange={handleAllRefine}
                            label={translate('plp.salesOffers.allToggle')}
                        />

                        <span className={styles.allCount}>
                            {translate('plp.facetSelection.resultCount', {
                                count: `${allCount}`,
                            })}
                        </span>
                    </div>
                </>
            }
        >
            {groupItems.map((item) => (
                <Fragment key={item.key}>
                    <RefinementListRow
                        label={item.label}
                        value={item.key}
                        count={item.count}
                        isRefined={item.isRefined}
                        isIndeterminate={item.isIndeterminate}
                        isDisabled={item.count === 0 && !item.isRefined && !item.isIndeterminate}
                        shouldShowCount
                        onRefine={handleGroupRefine}
                    />

                    {item.subItems.some((subItem) => subItem.isRefined) &&
                        item.subItems.map((subItem) => (
                            <RefinementListRow
                                key={subItem.key}
                                label={subItem.label}
                                value={subItem.value}
                                count={subItem.count}
                                isRefined={subItem.isRefined}
                                isSubItem
                                isDisabled={subItem.count === 0 && !subItem.isRefined}
                                shouldShowCount
                                onRefine={handleSubItemRefine}
                            />
                        ))}
                </Fragment>
            ))}
        </RefinementDropdown>
    );
};

export default RefinementSalesOffersDropdown;
